import { useEffect } from "react";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';


export default function CustomDatePicker({value ,onChange, label, disabled = false, className} : {value: any,  onChange: (value: Date | null, keyboardInputValue?: string | undefined, key?: string) => void, label?: string , disabled?: boolean, className?: string}) {


    return (<div>
        <LocalizationProvider  dateAdapter={AdapterDateFns}>

            <DesktopDatePicker
              className={className}
              disabled = {disabled}
              label={label}
              inputFormat="dd/MM/yyyy"
              value={value}
              onChange={onChange}
              renderInput={(params) => <TextField {...params} />}
            />

        </LocalizationProvider>

       
        
        
        </div>)


}